import React from "react";
import { X } from "lucide-react";

const pillClassMap = {
  green: "bg-[#DCFCE7] text-[#16A34A]",
  yellow: "bg-[#FEF3C7] text-[#A16207]",
  blue: "bg-[#DBEAFE] text-[#1D4ED8]",
};

const Chip = ({ label, tone = "blue" }) => (
  <span
    className={`inline-flex items-center rounded-full px-4 py-1 text-[11px]  leading-4 ${pillClassMap[tone]}`}
  >
    {label}
  </span>
);

const EmptyHint = ({ message }) => (
  <p className="text-xs text-[#9CA3AF]">{message}</p>
);

const CategoryDetailsModal = ({ isOpen, onClose, category }) => {
  if (!isOpen || !category) {
    return null;
  }

  console.log("cat. ",category)
  const subCategories = Array.isArray(category.subCategory)
    ? category.subCategory
    : [];
  const courseLevels = Array.isArray(category.categoryLevel)
    ? category.categoryLevel
    : [];
  const ageGroups = Array.isArray(category.categoryAgeGroup)
    ? category.categoryAgeGroup
    : [];

  return (
    <div className="fixed inset-0 z-[90] flex items-center justify-center bg-black/55 px-4 py-8">
     <div className="w-full max-w-[445px] overflow-hidden rounded-lg bg-white pb-9">
        <div className="flex items-center justify-between border-b border-[#E5E7EB] p-6">
          <h3 className="text-lg font-semibold leading-7 text-[#111827]">
            Category Details
          </h3>
          <button
            type="button"
            aria-label="Close category details modal"
            onClick={onClose}
            className="rounded-md p-1 text-[#9CA3AF] transition hover:bg-black/5"
          >
            <X size={20} />
          </button>
        </div>

        <div className="max-h-[calc(100vh-8rem)] overflow-y-auto">
          <div className="border-b border-[#E5E7EB] p-6">
            <div className="flex items-center gap-3">
              <span className="inline-flex h-10 w-10 items-center justify-center rounded-lg bg-[#923D8C20] text-[#923D8C]">
                {category.icon ? (
                  <img
                    src={category.icon.secureUrl}
                    alt={`${category.categoryName} icon`}
                  />
                ) : null}
              </span>

              <div className="flex-1">
                <h4 className="text-xl font-bold leading-7 text-[#111827]">
                  {category.categoryName}
                </h4>

                <span className="mt-1 inline-flex rounded-full capitalize bg-[#DCFCE7] px-2 py-1 text-xs font-semibold leading-4 text-[#166534]">
                  {category.visibility}
                </span>
              </div>
            </div>
            <p className="max-w-[300px] mt-4 text-sm  text-[#4B5563]">
              {category.categoryDescription}
            </p>
          </div>

          <div className="px-6 pt-6 pb-10 border-b border-[#E5E7EB]">
            <h4 className="mb-5 text-sm font-medium  text-[#111827]">
              Summary
            </h4>

            <div>
              <p className="mb-1 text-xs text-[#6B7280]">
                Subcategories ({subCategories.length})
              </p>
              <div className="flex flex-wrap gap-2.5">
                {subCategories.length > 0 ? (
                  subCategories.map((item,index) => (
                    <Chip
                      key={item._id}
                      label={item.title}
                      tone={index % 2 === 0 ? "green" : "yellow"}
                    />
                  ))
                ) : (
                  <EmptyHint message="No subcategories added" />
                )}
              </div>
            </div>

            <div>
              <p className="mb-1 mt-2 text-xs text-[#6B7280]">
                Course Levels ({courseLevels.length})
              </p>
              <div className="flex flex-wrap gap-2.5">
                {courseLevels.length > 0 ? (
                  courseLevels.map((item) => (
                    <Chip key={item} label={item.title} tone="blue" />
                  ))
                ) : (
                  <EmptyHint message="No course levels added" />
                )}
              </div>
            </div>

            <div>
              <p className="mb-1 mt-2 text-xs text-[#6B7280]">
                Age Groups ({ageGroups.length}):
              </p>
              <div className="flex flex-wrap gap-2.5">
                {ageGroups.length > 0 ? (
                  ageGroups.map((item) => (
                    <Chip key={item} label={item.title} tone="blue" />
                  ))
                ) : (
                  <EmptyHint message="No age groups added" />
                )}
              </div>
            </div>
          </div>
        </div>
      </div> 
    </div>
  );
};

export default CategoryDetailsModal;
